import { render, staticRenderFns } from "./ItemTagFormDialog.vue?vue&type=template&id=435882a9&"
import script from "./ItemTagFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ItemTagFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports